var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSolutec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #767a7d;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e90649;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_SOLUTEC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63,
    width: 44,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.8,59.6l-.5-.2a.4.4,0,0,0,.1-.3c0-.3-2.7-1.7-7.4-1.7s-6.4,1-6.4,2.3c0,3.5,16.9-1.6,16.9,6.1,0,2.8-3.7,4.9-11,4.9A24.1,24.1,0,0,1,.8,69.1a.5.5,0,0,0-.4.2H0l2.4-3.6h.4v.4c0,1.2,3.7,2.1,7.4,2.1,5.2,0,7-1.1,7-2.2,0-4.2-16.7,1-16.7-6.1,0-3.6,5.1-5.1,10.7-5.1A25.8,25.8,0,0,1,20,56.5c.4,0,.5-.1.5-.2H21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.1,62.8c0,5.1-5.3,7.9-12,7.9s-12-2.8-12-7.9,5.4-8,12-8S48.1,57.6,48.1,62.8Zm-19.9,0c0,3.5,3.6,5.4,7.9,5.4S44,66.3,44,62.8s-3.5-5.4-7.9-5.4S28.2,59.2,28.2,62.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,70.2c.6,0,.7-.1.7-.6V56c0-.5-.1-.6-.7-.6v-.3h5.7v.3c-.8,0-.9.1-.9.6V68H69.1c.7,0,1-.1,1-.5h.4V71h-.4c0-.3-.3-.5-1-.5H51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.5,64.8c0,2.5,1.4,3.4,6.5,3.4s6.5-.9,6.5-3.4V56c0-.5-.1-.6-.8-.6v-.3h5.7v.3c-.7,0-.8.1-.8.6v9.3c0,4.1-3.9,5.4-10.6,5.4s-10.6-1.3-10.6-5.4V56c0-.5-.1-.6-.8-.6v-.3h5.8v.3c-.7,0-.9.1-.9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.5,69.6c0,.5.1.6.9.6v.3h-5.9v-.3c.8,0,.9-.1.9-.6v-12h-7c-.7,0-.9.1-.9.5h-.4V54.5h.4c0,.4.2.6.9.6h18c.7,0,1-.2,1-.6h.4v3.6h-.4c0-.4-.3-.5-1-.5h-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.8,70.2c.6,0,.7-.1.7-.6V56c0-.5-.1-.6-.7-.6v-.3h18.7c.7,0,.9-.2.9-.5h.4v3.5h-.4c0-.4-.2-.5-.9-.5H127.6v3.7h9.1c.6,0,.9-.1.9-.5h.4v3.6h-.4c0-.4-.3-.5-.9-.5h-9.1V68h14.1c.7,0,1-.1,1-.5h.4V71h-.4c0-.3-.3-.5-1-.5H122.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.6,59.7h-.5a.8.8,0,0,0,.1-.4c0-.5-3.5-1.8-7.1-1.8s-8.7,1.5-8.7,5.4,4.1,5.4,9,5.4,7.5-1.6,7.5-2.6a.8.8,0,0,0-.2-.4h.3l3,3.1h-.6c-.8,0-3.1,2.5-10.3,2.5s-12.8-2.3-12.8-7.9,5.9-8,13-8c5.1,0,8.5,1.7,9.1,1.7a.6.6,0,0,0,.6-.3l.4.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 77,
    width: 170,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,84.3H10V79.5h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.3,79.5h.9v4.8h-1l-2-3.4h0v3.4h-.9V79.5h1l2,3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.2,81.7h2v2.6h-.6v-.6a2,2,0,0,1-1.6.8,2.3,2.3,0,0,1-2.2-2.6,2.3,2.3,0,0,1,2.4-2.5c1.5,0,2.1.9,2.1,1.6h-1a1,1,0,0,0-1.1-.8c-.7,0-1.3.5-1.3,1.7s.7,1.7,1.4,1.7.9-.1,1.1-1.1H25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.9,80.3H31.3v1.1h2.4v.8H31.3v1.3H34v.8H30.3V79.5h3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.5,79.5h1v4.8h-1l-2-3.4h0v3.4h-1V79.5h1.1l1.9,3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.1,84.3h-1V79.5h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.4,80.3H50.8v1.1h2.4v.8H50.8v1.3h2.7v.8H49.8V79.5h3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.1,79.5h2.4a1.4,1.4,0,0,1,1.6,1.4,1.2,1.2,0,0,1-.8,1.1c.4.2.6.3.6,1.2s0,.9.3,1H60a7.8,7.8,0,0,1-.1-.9c0-.7,0-1-.8-1h-1v1.9h-1Zm2.2,2.1c.5,0,.8-.2.8-.6a.7.7,0,0,0-.7-.7H58.1v1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.7,84.3H64.6V79.5h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.9,80.3H70.4v1.1h2.3v.8H70.4v1.3H73v.8H69.4V79.5h3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.4,84.3h-1V79.5h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.4,79.5h.9v4.8h-1l-2-3.4h0v3.4h-.9V79.5h1l1.9,3.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.4,84.5h-1V79.6h3.5v.9H95.4v1.1h2.1v.8H95.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103,79.4c.7,0,2.3.2,2.3,2.5s-1.6,2.6-2.3,2.6a2.3,2.3,0,0,1-2.3-2.6A2.2,2.2,0,0,1,103,79.4Zm0,4.2c.6,0,1.3-.3,1.3-1.7s-.7-1.7-1.3-1.7-1.3.3-1.3,1.7S102.5,83.6,103,83.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.7,79.6h2.4a1.4,1.4,0,0,1,1.5,1.4,1.2,1.2,0,0,1-.7,1.2c.4.1.6.3.6,1.2s0,.9.2,1h-1.1a2.5,2.5,0,0,1-.1-1c0-.7,0-.9-.8-.9h-1v1.9h-1Zm2.2,2.2c.5,0,.7-.2.7-.7s-.1-.6-.7-.6h-1.2v1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.9,84.5H120V80.4h0l-.9,4.1h-1l-.9-4.1h0v4.1h-.9V79.6h1.4l.9,3.9h0l.9-3.9h1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.8,84.5h-1.1l1.7-4.9h1.2l1.7,4.9h-1.1l-.3-1h-1.8Zm.6-1.9h1.2l-.6-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.5,84.5h-1v-4H130v-.9h4v.9h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.7,84.5h-1.1V79.6h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.3,84.8l-.6-.5a1.9,1.9,0,0,1-1.2.3,2.3,2.3,0,0,1-2.4-2.5,2.4,2.4,0,1,1,4.7,0,2.6,2.6,0,0,1-.5,1.7l.5.5Zm-1.2-2.2.5.5a2.5,2.5,0,0,0,.2-1c0-1.4-.8-1.7-1.3-1.7s-1.3.3-1.3,1.7.7,1.7,1.3,1.7l.5-.2-.5-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.2,82.8c0,1.3-.7,1.8-1.9,1.8a2,2,0,0,1-1.6-.6,3.6,3.6,0,0,1-.4-1.1V79.6h1.1v3.2c0,.7.4,1,.8,1a.9.9,0,0,0,1-1V79.6h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.6,80.5H158v1h2.3v.9H158v1.2h2.7v.9H157V79.6h3.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 75,
    cy: 32.3,
    r: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83,36.2a4,4,0,0,0,3.9-3.9A3.9,3.9,0,0,0,83,28.4a3.8,3.8,0,0,0-3.9,3.9A3.9,3.9,0,0,0,83,36.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.9,29.3A3.9,3.9,0,1,0,83,25.4,4,4,0,0,0,86.9,29.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91,22.4a4,4,0,0,0,3.9-3.9A3.9,3.9,0,0,0,91,14.6a3.8,3.8,0,0,0-3.9,3.9A3.9,3.9,0,0,0,91,22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.9,29.1a3.9,3.9,0,1,0-3.8-3.8A3.8,3.8,0,0,0,78.9,29.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83,22.4a3.9,3.9,0,0,0,3.9-3.9A3.8,3.8,0,0,0,83,14.6a3.9,3.9,0,0,0-3.9,3.9A4,4,0,0,0,83,22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95,15.4a3.9,3.9,0,1,0,0-7.8,4,4,0,0,0-3.9,3.9A4,4,0,0,0,95,15.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87,15.4a3.9,3.9,0,1,0,0-7.7,3.9,3.9,0,1,0,0,7.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 102.9,
    cy: 11.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.6,15.5a3.9,3.9,0,0,0,3.9-3.9,3.8,3.8,0,0,0-3.9-3.9,3.9,3.9,0,0,0-3.9,3.9A4,4,0,0,0,111.6,15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.4,36.1a3.9,3.9,0,0,0,3.9-3.9,4,4,0,0,0-3.9-3.9,3.9,3.9,0,0,0-3.9,3.9A3.8,3.8,0,0,0,58.4,36.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67,36.1a3.8,3.8,0,0,0,3.9-3.9,3.9,3.9,0,1,0-7.7,0A3.8,3.8,0,0,0,67,36.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSolutec);
export default __webpack_public_path__ + "static/media/logo-solutec.3932d3e685fa7ca298e1d0fee96bcc7d.svg";
export { ForwardRef as ReactComponent };